import moment from "moment";
import userService from "../../services/user.service";
import { ActionTypes } from "../Constants/ActionTypes";
import { isArray } from "highcharts";

export const setErrorMessage = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_ERROR_MESSAGE,
    payload: payload,
  });
};

export const setOdkData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_ODK_DATA,
    payload: payload,
  });
};

export const ChangeVideoStreamStatus = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.VIDEO_STREAM_STATUS,
    payload: payload,
  });
};

export const setVideoStreamChannelList = (dispatch) => {
  userService
    .getChannelDetails()
    .then((res) => {
      const channelListWithAngleName = res?.data?.data?.map((item, index) => ({
        ...item,
        angleName: `Angle ${index + 1}`,
      }));
      dispatch({
        type: ActionTypes.SET_VIDEO_STREAM_CHANNEL_LIST,
        payload: channelListWithAngleName,
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const startVideoStream = (dispatch, payload) => {
  userService
    .startVideoStream(payload)
    .then(() => {
      dispatch({
        type: ActionTypes.START_STREAMING,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.VIDEO_STREAM_STATUS,
        payload: true,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.VIDEO_STREAMING_STARTED_POPUP,
        payload: true,
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const stopVideoStream = (dispatch, payload) => {
  userService
    .stopVideoStream(payload)
    .then(() => {
      dispatch({
        type: ActionTypes.STOP_STREAMING,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.VIDEO_STREAM_STATUS,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Video Stream Stopped.",
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const videoStreamingStartedPopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.VIDEO_STREAMING_STARTED_POPUP,
    payload: payload,
  });
};

export const setLatestStartedChannelName = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_LATEST_STARTED_CHANNEL_NAME,
    payload: payload,
  });
};

export const addIVSStageDetails = (dispatch, payload) => {
  userService
    .addAvsChannel(payload)
    .then((res) => {
      dispatch({
        type: ActionTypes.SET_CURRENT_CHANNEL_INFORMATION,
        payload: res?.data.data,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const addAvsChannelDetails = (dispatch, payload) => {
  userService
    .addAvsChannel(payload)
    .then((res) => {
      dispatch({
        type: ActionTypes.SET_CURRENT_CHANNEL_INFORMATION,
        payload: res?.data.data,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Camera is connected.",
            open: true,
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const setFromSocketAvsChannelList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ADD_AVS_CHANNEL_DETAILS,
    payload: payload,
  });
};

export const setAvsChannelList = async (dispatch, schoolId) => {
  await userService
    .getAllAvsChannelList(schoolId)
    .then((res) => {
      const sortedList = res?.data?.data.sort((a, b) => a.id - b.id);
      dispatch({
        type: ActionTypes.SET_ALL_AVS_CHANNEL_LIST,
        payload: sortedList,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const updateChannelStatus = (dispatch, payload) => {
  const { id, channelName, streamKey, ingestUrl, playbackUrl } =
    payload?.currentChannel;
  userService
    .updateChannelStatus(
      id,
      channelName,
      streamKey,
      ingestUrl,
      playbackUrl,
      payload?.channelStatus
    )
    .then((res) => {})
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong!.",
        },
      });
    });
};

export const setRecording = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_RECORDING,
    payload: payload,
  });
};

export const setIVSCameraAngle = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_CAMERA_ANGLE,
    payload: payload,
  });
};

export const deleteAllIvsChannels = async (dispatch, payload) => {
  let channelIds;
  dispatch({
    type: ActionTypes.SET_DISABLE_SCREEN,
    payload: true,
  });
  const { socket, item, getAllLiveChannel, setLoadingButton } = payload;
  const { schoolId, channels } = item;
  const streamingEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  try {
    setLoadingButton(schoolId);
    dispatch({
      type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
      payload: false,
    });
    let channelArns = channels.map((ele) => ele.channelArn);
    channelIds = channels.map((ele) => {
      return {
        id: ele.channelId ? ele.channelId : ele.id,
        isAssigned: false,
        streamingEndTime,
      };
    });
    const result = await userService.stopIvsStream(channelArns);
    result.data.data.forEach((ele) => {
      if (ele.message === "Channel deleted successfully") {
        //remove deleted channel arn from array
        let index = channelArns.indexOf(ele.channelArn);
        if (index > -1) {
          channelArns.splice(index, 1);
        }
      }
    });
    if (channelArns.length != 0) {
      await userService.deleteChannel(channelArns);
    }
    const response = await userService.updateChannelStatus(channelIds);
    socket.emit("stopStreaming", response.data?.data);
    getAllLiveChannel();
    dispatch({
      type: ActionTypes.OPEN_SUCCESS_POPUP,
      payload: {
        successPopUp: {
          message: "Streams Stopped Successfully!",
          open: true,
        },
      },
    });
  } catch (error) {
    if (channelIds.length != 0) {
      const response = await userService.updateChannelStatus(channelIds);
      socket.emit("stopStreaming", response.data?.data);
      getAllLiveChannel();
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Streams Stopped Successfully!",
            open: true,
          },
        },
      });
    } else {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong!.",
        },
      });
    }
  } finally {
    setLoadingButton(null);
    dispatch({
      type: ActionTypes.SET_DISABLE_SCREEN,
      payload: false,
    });
  }
};

export const deleteIvsChannel = (dispatch, payload) => {
  const { socket, item, getAllLiveChannel, setLoadingButton, userId } = payload;
  const { channelId, channelArn, id } = item;
  const streamingEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  dispatch({
    type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
    payload: false,
  });
  setLoadingButton(channelId ? channelId : id);
  userService
    .stopIvsStream([channelArn])
    .then((res) => {
      if (res.data.data[0].message !== "Channel deleted successfully") {
        userService.deleteChannel([channelArn]);
      }
      userService
        .updateChannelStatus([
          {
            id: channelId ? channelId : id,
            isAssigned: false,
            streamingEndTime,
          },
        ])
        .then((response) => {
          if (userId === item?.userId?.toString()) {
            dispatch({
              type: ActionTypes.OPEN_STREAM_CAMERA,
              payload: false,
            });
          }
          socket.emit("stopStreaming", response.data?.data);
          getAllLiveChannel();
          dispatch({
            type: ActionTypes.OPEN_SUCCESS_POPUP,
            payload: {
              successPopUp: {
                message: "Stream Stopped Successfully!",
                open: true,
              },
            },
          });
          setLoadingButton(null);
        });
    })
    .catch((err) => {
      //In case channel gets deleted but status not updated in db
      userService
        .updateChannelStatus([
          {
            id: channelId ? channelId : id,
            isAssigned: false,
            streamingEndTime,
          },
        ])
        .then((response) => {
          if (userId === item?.userId?.toString()) {
            dispatch({
              type: ActionTypes.OPEN_STREAM_CAMERA,
              payload: false,
            });
          }
          socket.emit("stopStreaming", response.data?.data);
          getAllLiveChannel();
          dispatch({
            type: ActionTypes.OPEN_SUCCESS_POPUP,
            payload: {
              successPopUp: {
                message: "Channel Deleted Successfully!",
                open: true,
              },
            },
          });
        })
        .catch(() => {
          dispatch({
            type: ActionTypes.OPEN_FAIL_DIALOG,
            payload: {
              open: true,
              message: "Something Went Wrong!.",
            },
          });
        });
    })
    .finally(() => {
      setLoadingButton(null);
    });
};

export const deleteRecordedVideo = (dispatch, payload) => {
  const { id, recording } = payload;
  const updatedRecording = recording.filter((ele) => {
    return id !== ele.master_url;
  });
  dispatch({
    type: ActionTypes.SET_RECORDING,
    payload: updatedRecording,
  });
  dispatch({
    type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
    payload: false,
  });
  dispatch({
    type: ActionTypes.OPEN_SUCCESS_POPUP,
    payload: {
      successPopUp: {
        message: "Video Deleted Successfully",
        open: true,
      },
    },
  });
};

export const renameRecordedVideo = (dispatch, payload) => {
  const { recording, item, videoName, schoolId } = payload;
  const checkFile = recording.filter((ele) => {
    return ele.fileName === videoName;
  });
  if (checkFile.length > 0) {
    dispatch({
      type: ActionTypes.SET_ERROR_MESSAGE,
      payload: "File name already exists.",
    });
  } else {
    userService
      .renameVideo(item.id, videoName, schoolId)
      .then((response) => {
        const updatedRecording = recording.map((ele) => {
          if (ele.id === item.id) {
            ele.fileName = videoName;
          }
          return ele;
        });
        dispatch({
          type: ActionTypes.RENAME_RECORDING,
          payload: updatedRecording,
        });
        dispatch({
          type: ActionTypes.CLOSE_RENAME_POPUP,
          payload: payload,
        });
      })
      .catch((error) => {
        dispatch({
          type: ActionTypes.OPEN_FAIL_DIALOG,
          payload: {
            open: true,
            message: "Something Went Wrong!.",
          },
        });
      });
  }
};

export const setCurrentStageInformation = (dispatch, payload) => {
  const { id } = payload?.currentChannel;
  const { channelStatus, videoStreamAvsChannelList, schoolId } = payload;
  const streamingEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const parentChannelId = videoStreamAvsChannelList?.filter(
    (ele) => ele?.isPrimaryChannel === true
  )[0]?.id;
  let sendData = {
    id: id,
    isAssigned: channelStatus,
    ...(channelStatus ? {} : { streamingEndTime: streamingEndTime }),
  };
  if (channelStatus && parentChannelId) {
    sendData.parentChannelId = parentChannelId;
  }
  userService
    .updateChannelStatus([sendData])
    .then((res) => {
      setAvsChannelList(dispatch, schoolId);
      // if (channelStatus) {
      //   payload?.socket?.emit("startStreaming", res.data?.data);
      // } else {
      //   payload?.socket?.emit("stopStreaming", res.data?.data);
      // }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong!.",
        },
      });
    });
};

export const setCurrentChannelInformation = (dispatch, payload) => {
  const { id } = payload?.currentChannel;
  const { channelStatus, videoStreamAvsChannelList, schoolId } = payload;
  const streamingEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const parentChannelId = videoStreamAvsChannelList?.filter(
    (ele) => ele?.isPrimaryChannel === true
  )[0]?.id;
  let sendData = {
    id: id,
    isAssigned: channelStatus,
    ...(channelStatus ? {} : { streamingEndTime: streamingEndTime }),
  };
  if (channelStatus && parentChannelId) {
    sendData.parentChannelId = parentChannelId;
  }
  userService
    .updateChannelStatus([sendData])
    .then((res) => {
      setAvsChannelList(dispatch, schoolId);
      if (channelStatus) {
        payload?.socket?.emit("startStreaming", res.data?.data);
      } else {
        payload?.socket?.emit("stopStreaming", res.data?.data);
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong!.",
        },
      });
    });
};

export const setLiveChannelsList = (dispatch) => {
  dispatch({
    type: ActionTypes.FULL_PAGE_LOADING,
    payload: true,
  });
  userService
    .fetchAllLiveChannelDetails()
    .then((res) => {
      const allChannels = res?.data?.data;
      dispatch({
        type: ActionTypes.FETCH_ALL_LIVE_CHANNELS,
        payload: allChannels?.length > 0 ? allChannels : [],
      });
      dispatch({
        type: ActionTypes.FULL_PAGE_LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.FULL_PAGE_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong!.",
        },
      });
    });
};

export const setOpenStreamCamera = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.OPEN_STREAM_CAMERA,
    payload: payload,
  });
};

export const setIPCameraStreamingStatus = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.IP_CAMERA_VIDEO_STREAMING_STATUS,
    payload: payload,
  });
};

export const updateLiveChannels = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.UPDATE_LIVE_CHANNELS,
    payload: payload,
  });
};

export const resetVideoStreamingInformation = (dispatcn) => {
  dispatcn({
    type: ActionTypes.RESET_VIDEO_STREAMING_INFORMATION,
  });
};

export const updateActiveIpCameraCount = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.UPDATE_ACTIVE_IP_CAMERA_COUNT,
    payload: payload,
  });
};

export const toggleIPCameraRequestPopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.IP_CAMERA_REQUEST_POPUP,
    payload: payload,
  });
};

export const requestIPCameraConnection = (dispatch, payload) => {
  userService
    .requestCameraConnection(
      payload?.userName,
      payload?.password,
      payload?.IPAddressOfCamera
    )
    .then((res) => {
      if (res?.data?.success === true) {
        dispatch({
          type: ActionTypes.IP_CAMERA_PREVIEW_STATUS,
          payload: { ...payload, previewUrl: res?.data?.data },
        });

        dispatch({
          type: ActionTypes.IP_CAMERA_REQUEST_POPUP,
          payload: payload,
        });

        dispatch({
          type: ActionTypes.IP_CAMERA_ANGLE_LIST,
          payload: {
            angle: payload?.allocatedAngle,
            status: true,
          },
        });
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: "Camera Connected Successfully.",
              open: true,
            },
          },
        });
      } else {
        throw new Error();
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong While Connecting Camera!.",
        },
      });
    });
};

export const requestIPCameraDisconnection = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
    payload: false,
  });

  dispatch({
    type: ActionTypes.IP_CAMERA_PREVIEW_STATUS,
    payload: { ...payload, previewUrl: "" },
  });

  dispatch({
    type: ActionTypes.IP_CAMERA_ANGLE_LIST,
    payload: { angle: payload?.allocatedAngle, status: false },
  });

  dispatch({
    type: ActionTypes.ALLOCATE_IP_CAMERA_ANGLE,
    payload: payload,
  });

  dispatch({
    type: ActionTypes.OPEN_SUCCESS_POPUP,
    payload: {
      successPopUp: {
        message: "Camera Disconnected Successfully.",
        open: true,
      },
    },
  });
};

export const cancelIPCameraRequest = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ALLOCATE_IP_CAMERA_ANGLE,
    payload: payload,
  });
  dispatch({
    type: ActionTypes.IP_CAMERA_REQUEST_POPUP,
    payload: payload,
  });
};

export const allocateIPCameraAngle = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ALLOCATE_IP_CAMERA_ANGLE,
    payload: payload,
  });
};

export const setIPCameraAngleList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.IP_CAMERA_ANGLE_LIST,
    payload: payload,
  });
};
